import React, { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
export const loadRules = () => (cache ||= api.get("/rules").then((r) => r.data).catch(() => { cache = null; return {}; }));
export const RULES_MSG = "Prano rregullat e publikimit";
export const clearRules = () => { cache = null; };

export function RulesBox({ catKey, accepted, onAccept }) {
  const [all, setAll] = useState(null);
  useEffect(() => { loadRules().then(setAll); }, []);
  if (!all) return null;
  const r = all[catKey] || all.default;
  if (!r) return null;
  return (
    <div data-testid="rules-box" className="bg-amber-50 border border-amber-200 rounded-2xl p-4 text-sm text-slate-700 mt-4 break-words">
      {r.title && <p className="font-extrabold text-amber-700">{r.title}</p>}
      {r.intro && <p className="mt-2 font-semibold">{r.intro}</p>}
      {!!r.items?.length && (
        <ul className="mt-2 space-y-1 list-disc pl-4 text-slate-600">
          {r.items.map((it, i) => <li key={i}>{it}</li>)}
        </ul>
      )}
      {r.footer && <p className="mt-2 font-medium">{r.footer}</p>}
      <button type="button" data-testid="rules-accept" onClick={() => onAccept(!accepted)} className="flex items-center gap-2 text-sm text-left w-full mt-3">
        <span className={`w-5 h-5 rounded border flex items-center justify-center shrink-0 ${accepted ? "bg-emerald-600 border-emerald-600 text-white" : "border-slate-300 bg-white"}`}>{accepted && "✓"}</span>
        <span className="font-medium text-slate-700">{r.accept || "E kam lexuar dhe pranoj rregullat."}</span>
      </button>
    </div>
  );
}
